export const defaultSEO = {
    title: "VitAnimal - Kedi ve Köpek Sağlık Ürünleri",
    description: "VitAnimal ile evcil hayvanlarınızın sağlığını destekleyin. En kaliteli kedi ve köpek takviyeleri, vitaminleri ve bakım ürünleri.",
    keywords: [
        "vitanimal",
        "kedi takviyeleri",
        "köpek takviyeleri",
        "kedi vitamini",
        "köpek vitamini",
        "kedi bağışıklık güçlendirici",
        "fip tedavisi destek",
        "kedi fip vitamini",
        "evcil hayvan sağlığı",
        "kedi eklem sağlığı",
        "kedi tüy sağlığı",
        "köpek eklem sağlığı",
        "en iyi kedi vitaminleri",
        "bağışıklık destekleyici takviyeler",
        "veteriner onaylı kedi takviyeleri",
        "kedi iştah açıcı"
    ],
    author: "VitAnimal",
    canonicalUrl: "https://pet.vitanimal.tr"
};
